module.exports = __webpack_public_path__ + "img/sleeve cap back.5e5b37df.png";